import { combineReducers } from '@reduxjs/toolkit';
import auth from '../redux/slices/authSlice';
import aiSlice from '../redux/slices/aiSlice';
import uiSlice from '../redux/slices/uiSlice';
import portfolio from '../redux/slices/portfolioSlice';
import businessCycle from '../redux/slices/businessCycleSlice';

const rootReducer = combineReducers({
  auth,
  aiSlice,
  uiSlice,
  portfolio,
  businessCycle,
});

export default rootReducer;